import { createSvgIcon } from "@material-ui/core/utils";
import React from "react";

export const MinusIcon = createSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M19 12C19 12.5523 18.5523 13 18 13L6 13C5.44771 13 5 12.5523 5 12C5 11.4477 5.44771 11 6 11L18 11C18.5523 11 19 11.4477 19 12Z"
    fill="currentColor"
  />,
  "MinusIcon"
);
